import 'arrive'
import $ from 'jquery'
import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper'

Swiper.use([Navigation, Pagination, Scrollbar])

export default function gallery_modal($element) {

  const $gallery = $element.querySelector('.gallery');

  const slidesInView = parseFloat($gallery.getAttribute('data-slides-inview'));
  const slidesCentered = parseInt($gallery.getAttribute('data-slides-center'));
  const slidesGap = parseInt($gallery.getAttribute('data-slides-gap'));
  const slidesMobile = parseFloat($gallery.getAttribute('data-slides-mobile'));
  const overlay = $element.querySelector('.zoom-overlay');
  const navPrev = $gallery.querySelector('.slider-nav-prev');
  const navNext = $gallery.querySelector('.slider-nav-next');
  const closeOverlay = (e) => {
    e.stopPropagation();
    overlay.classList.remove('active');
    const image = overlay.querySelector('img');
    const transitionSpeed = 300;
    $(image).css({
      'height': $(image).data('start-h'),
      'width': $(image).data('start-w'),
      'transition': '0.' + (transitionSpeed / 100) + 's',
      'left': $(image).data('start-left'),
      'top': $(image).data('start-top')
    });
    setTimeout(() => {
      $(image).removeAttr('style')}, transitionSpeed);
  }
  let slidesTablet = slidesInView;

  if ( slidesInView >= 2 ) {
    slidesTablet = slidesInView - 1;
  }

  let swiper = new Swiper($gallery, {

    loop: true,
    speed: 600,
    direction: 'horizontal',
    effect: 'slide',
    centeredSlides: slidesCentered,
    initialSlide: 1,
    keyboard: false,
    allowTouchMove: false,
    slidesPerView: 1.8,
    spaceBetween: slidesGap,

    navigation: {
      nextEl: navNext,
      prevEl: navPrev,
    },

    autoplay: false,
    breakpoints: {

      0: {
        allowTouchMove: true,
        slidesPerView: 1.2,
        spaceBetween: 10,
      },

      768: {
        slidesPerView: 1.4,
      },

      992: {
        slidesPerView: 1.8
      }

    },

  });

  $($gallery).find('.swiper-slide img').each(function() {
    const height = $(this).height();
    const width = $(this).width();
    if(height > width) {
      $(this).addClass('vertical-orientation');
    }
    else {
      $(this).addClass('horizontal-orientation');
    }

    this.addEventListener('click', function(event) {
        var top = $(this).offset().top - document.documentElement.scrollTop;
        var left = $(this).offset().left - document.documentElement.scrollLeft;
        overlay.classList.add('active')
        const viewW = (qty = 1) => (Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) * qty);
        const viewH = (qty = 1) => (Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0) * qty);
        const image = overlay.querySelector('img');
        const isPortrait = viewH() > viewW();
        const isImagePortrait = $(this).height() > $(this).width();
        const imgPotenetialWidth = viewW(100) / $(this).width();
        $(image).attr('src', $(this).attr('src'));
        $(image).data('start-w', $(this).width());
        $(image).data('start-h', $(this).height());
        $(image).data('start-left', left);
        $(image).data('start-top', top);
        $(image).css({
          'position': 'relative',
          'left': Math.floor(left),
          'top': Math.floor(top),
          'height': $(this).height(),
          'width': $(this).width(),
          'transition': '0.3s'
        });
        setTimeout(() => {
          $(image).css({
            'height': '90vh',
            'width': '90vw',
            'top': '5vh',
            'left': '5vw',
            'object-fit': 'contain'
          });
        });

    })

    overlay.querySelector('.zoom-close-btn').addEventListener('click',closeOverlay);
    overlay.addEventListener('click',closeOverlay);
  });

  const closeWithEsc = (e) => {
    if (e.key === 'Escape') {
      if(overlay.classList.contains('active')) {
        overlay.querySelector('.zoom-close-btn').click()
      } else {
        if ($element.classList.contains('show')) {
          $element.querySelector('.btn-close').click();
          window.removeEventListener('keydown', closeWithEsc);
        }
      }
    }
  }

  window.addEventListener('keydown', closeWithEsc);
}

$(document).ready(function() {
  $('section.block-gallery-masonry .box').click(function(e) {
    $('section.block-gallery-masonry .btn-modal').click();
  });
})